var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6814_30470)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 39.5977,
    width: 39,
    height: 39,
    rx: 19.5,
    transform: "rotate(-90 1 39.5977)",
    stroke: "#191919"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2852 16.9727L17.5664 20.6914C17.293 20.9648 17.293 21.375 17.5664 21.6211L18.168 22.25C18.4414 22.4961 18.8516 22.4961 19.0977 22.25L21.7227 19.5977L24.375 22.25C24.6211 22.4961 25.0312 22.4961 25.3047 22.25L25.9336 21.6211C26.1797 21.375 26.1797 20.9648 25.9336 20.6914L22.2148 16.9727C21.9414 16.7266 21.5312 16.7266 21.2852 16.9727Z",
    fill: "#191919"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6814_30470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.5 40.0977)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.39b76ca4b955458bad90974c5ff59b48.svg";
export { ForwardRef as ReactComponent };